import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { BookingProvider } from './contexts/BookingContext';
import { useScrollToTop } from './hooks/useScrollToTop';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import StartPage from './pages/StartPage';
import TransportPage from './pages/TransportPage';
import StayPage from './pages/StayPage';
import WorkspacePage from './pages/WorkspacePage';
import CommunityPage from './pages/CommunityPage';
import CultureExperiencePage from './pages/CultureExperiencePage';
import SummaryPage from './pages/SummaryPage';
import TicketsPage from './pages/TicketsPage';
import CulturePage from './pages/CulturePage';
import NomadPage from './pages/NomadPage';
import TransportIntroPage from './pages/TransportIntroPage';
import StayIntroPage from './pages/StayIntroPage';
import WorkspaceIntroPage from './pages/WorkspaceIntroPage';
import OrderHistoryPage from './pages/OrderHistoryPage';

// 內部組件，使用 Hook
const AppContent: React.FC = () => {
  useScrollToTop(); // 使用滾動到頂端的 Hook

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-16">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/start" element={<StartPage />} />
          
          {/* 服務介紹頁面 */}
          <Route path="/transport" element={<TransportIntroPage />} />
          <Route path="/stay" element={<StayIntroPage />} />
          <Route path="/cowork" element={<WorkspaceIntroPage />} />
          
          {/* 排行程表單頁面 */}
          <Route path="/transport-booking" element={<TransportPage />} />
          <Route path="/stay-booking" element={<StayPage />} />
          <Route path="/workspace-booking" element={<WorkspacePage />} />
          
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/culture-experience" element={<CultureExperiencePage />} />
          <Route path="/summary" element={<SummaryPage />} />
          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/culture" element={<CulturePage />} />
          <Route path="/nomad" element={<NomadPage />} />
          
          {/* 會員功能頁面 */}
          <Route path="/order-history" element={<OrderHistoryPage />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BookingProvider>
        <Router>
          <AppContent />
        </Router>
      </BookingProvider>
    </LanguageProvider>
  );
}

export default App; 